import axios from '@/plugins/axios'
import CookieOperation from '@/plugins/cookie'
import colorConvert from './colorConvert'
import { changeThemeColor } from './elementui_theme'

/**
 * 维护一个formulaColor颜色计算对象来将主颜色转换成不同的子颜色
 * 使用:root伪元素设置全局变量，59期手动替换了所有需要改为变量的地方，后续开发，需要设置颜色的地方也要使用变量
 * 引入不同的scss文件是为了更改框架的主题颜色，但是存在手动覆盖了框架主题颜色和未使用框架的模块，需要手动维护
 * 注意： 使用主题统一颜色风格类型后，需要尽量使用统一的颜色种类，减少子类颜色（ui），否则容易混乱难以管理，目前ui上使用的颜色对应的转换在formulaColor中记录
 * */
let primaryColor = ''
let theme = ''

// 使用主题
export default {
  async install (Vue) {
    let domain = document.domain
    if (domain === 'localhost') {
      domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '8854.rc-dev-test.ywsoftware.cn'
    }
    let params = { 'domain': domain }
    await axios.get('/system-api/application/getSettingByDomain', { params }).then(res => {
      if (res.data.data) {
        theme = res.data.data.themeColor
      }
    })

    // todo： 开发用，后续可删除
    // theme = 'themeGreen' // 绿色 #2FA276 rgba(47, 162, 118, 1)
    // theme = 'themeBlue' // 蓝色 #4592E4 rgba(69, 146, 228, 1)
    // theme = 'themeOrange' // 橙色 #F67613 rgba(246, 118, 19, 1)
    // theme = 'themeBrown' // 棕色 #C59871 rgba(197, 152, 113, 1)
    // theme = 'defaultColor' // 老系统的样式

    if (!theme || theme === 'defaultColor') {
      theme = ''
    }
    switch (theme) {
      case 'themeBlue':
        primaryColor = '#4592E4'
        break
      case 'themeGreen':
        primaryColor = '#2FA276'
        break
      case 'themeOrange':
        primaryColor = '#F67613'
        break
      case 'themeBrown':
        primaryColor = '#C59871'
        break
    }
    if (!primaryColor) {
      return null
    }
    Vue.$theme = {themeColor: theme}
    Object.defineProperties(Vue.prototype, {
      $theme: {
        configurable: false,
        get () {
          return {themeColor: theme, themeColorStyle: primaryColor}
        }
      }
    })
    // 更改主题颜色
    changeThemeColor(primaryColor)
    document.documentElement.setAttribute('theme', theme)
    disableEditThemeByConsole(theme)
    let colors = colorConvert(primaryColor)
    let cssText = ''
    Object.keys(colors).forEach(key => {
      cssText = cssText + `${key}:${colors[key]};`
    })
    document.documentElement.setAttribute('style', cssText)
  }
}

function disableEditThemeByConsole (theme) {
  if (MutationObserver) {
    let mo = new MutationObserver(function () {
      const wm = document.documentElement
      if ((wm.getAttribute('theme') !== theme) || !theme) {
        document.documentElement.setAttribute('theme', theme)
      }
    })
    mo.observe(document.documentElement, {
      attributes: true
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/theme/theme.js